import React from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import FacilitiesSection from "@/components/FacilitiesSection";
import ClassesSection from "@/components/ClassesSection";
import PricingSection from "@/components/PricingSection";
import LocationSection from "@/components/LocationSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-[#0A0A0A] min-h-screen">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <FacilitiesSection />
      <ClassesSection />
      <PricingSection />
      <LocationSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
